import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-loans-contract',
  templateUrl: './loans-contract.component.html',
  styleUrls: ['./loans-contract.component.scss']
})
export class LoansContractComponent implements OnInit {

  dtTrigger: Subject<any> = new Subject<any>();
  dtOptions: any = {};
  role: any;
  loading: any;
  contracts: any;

  constructor(private authService: AuthenticationService, private router: Router) { }

  ngOnInit(): void {
    this.role = this.authService.getUserRole();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      responsive: true,
      processing: true,
      dom: 'Bfrtip',
      buttons: [ 'excel', 'print' ],
      order: [[1, 'desc']],
      columnDefs: [
        { responsivePriority: 1, targets: -1 },
        { responsivePriority: 1, targets: -2 }
      ]
    };

    this.getLoanContracts();
  }

  getLoanContracts(){
    this.authService.getLoanContracts().then(async (res:any)=>{
        console.log(res);
      //added/
      // let userId = this.authService.getUserId();
      // let userRole = this.authService.getUserRole();
      // console.log(userRole);
      // if(userRole == "producer"){
      //   res = res.filter((x:any)=> x.idProducer == userId);
      // }
      //added-end
      this.contracts = await res.map((contract:any)=>{
        //stringify
        let keys = Object.keys(contract);
        keys.forEach((key, index) => {
          if(typeof contract[key] != 'string') return
          if(this.isJsonString(contract[key])){
            console.log(key);
            contract[key] = JSON.parse(contract[key]);
            console.log(contract[key]);
          }
        });
        return contract;
      })

      console.log(this.contracts);
      

      // this.contracts = res;
      // console.log(this.contracts);
    })
  }

  contractDetails(id:any){
    this.router.navigateByUrl('loans/contract-details/'+id);
  }

  isJsonString(str:any) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

}
